// ©2024 Austin App House. All rights reserved.
import React from 'react';

const SPIRAL_CIRCLES = [
  { className: 'r1', r: 120, strokeWidth: 24, dash: '150 59 50 59' },
  { className: 'r2', r: 180, strokeWidth: 26, dash: '80 61 220 61 40 61' },
  { className: 'r3', r: 240, strokeWidth: 28, dash: '300 63 60 63 120 63' },
  { className: 'r4', r: 300, strokeWidth: 30, dash: '60 65' },
  { className: 'r5', r: 360, strokeWidth: 32, dash: '180 67 90 67' },
  { className: 'r6', r: 420, strokeWidth: 34, dash: '250 69 40 69 80 69' },
  { className: 'r7', r: 480, strokeWidth: 36, dash: '70 71 140 71 210 71' },
  { className: 'r8', r: 540, strokeWidth: 38, dash: '400 73 40 73' },
  { className: 'r9', r: 600, strokeWidth: 40, dash: '150 75 50 75' },
  { className: 'r10', r: 660, strokeWidth: 42, dash: '80 77 220 77 40 77' },
  { className: 'r11', r: 720, strokeWidth: 44, dash: '300 79 60 79 120 79' },
  { className: 'r12', r: 780, strokeWidth: 46, dash: '60 81' },
  { className: 'r13', r: 840, strokeWidth: 48, dash: '180 83 90 83' },
];

const SpiralLoader = ({ size = 'md', className = '' }) => (
  <svg
    className={`wurqly-spiral-loader wurqly-spiral-loader--${size}${className ? ` ${className}` : ''}`}
    viewBox="0 0 1800 1800"
    role="presentation"
    aria-hidden="true"
    focusable="false"
  >
    {SPIRAL_CIRCLES.map((circle) => (
      <circle
        key={circle.className}
        className={circle.className}
        cx="900"
        cy="900"
        r={circle.r}
        strokeWidth={circle.strokeWidth}
        strokeDasharray={circle.dash}
      />
    ))}
  </svg>
);

export default SpiralLoader;
